export default {
  path: 'statement',
  meta: {
    title: '账目中心'
  },
  component: () => import('@/components/parent-view'),
  name: 'statement',
  children: [
    {
      path: '',
      meta: {
        title: '对账列表'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: 'list',
          meta: {
            title: '对账列表',
            ignoreBreadCrumb: true
          },
          name: 'self-statement-list',
          component: () => import('@/view/v5/statement/list.vue')
        },
        {
          path: 'detail/:code',
          meta: {
            title: '对账单详情',
            hideInTabBar: true,
            detail: true
          },
          name: 'self-statement-detail',
          component: () => import('@/view/v5/statement/detail.vue')
        },
        {
          path: 'edit/:code',
          meta: {
            title: '修改对账单',
            hideInTabBar: true
          },
          name: 'self-statement-edit',
          component: () => import('@/view/v5/statement/detail.vue')
        },
        {
          path: 'combineDetail/:code',
          meta: {
            title: '合并对账单详情',
            hideInTabBar: true
          },
          name: 'self-statement-combine-detail',
          component: () => import('@/view/v5/statement/combineDetail.vue')
        },
        {
          path: 'audit/:code',
          meta: {
            title: '对账单审核',
            hideInTabBar: true,
            audit: true
          },
          name: 'self-statement-audit',
          component: () => import('@/view/v5/statement/detail.vue')
        },
        {
          path: 'project/:code',
          meta: {
            title: '项目详情',
            hideInTabBar: true
          },
          name: 'self-statement-project',
          component: () => import('@/view/v5/statement/project.vue')
        },
        {
          path: 'pay',
          meta: {
            title: '供应商流水登记',
            billType: 1
          },
          name: 'self-statement-pay',
          component: () => import('@/view/v5/statement/record/pay.vue')
        },
        {
          path: 'get',
          meta: {
            title: '客户流水登记',
            billType: 1
          },
          name: 'self-statement-get',
          component: () => import('@/view/v5/statement/record/get.vue')
        }
      ]
    },
    {
      path: 'payment',
      meta: {
        title: '到账管理',
        notCache: false
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          name: 'cache-self-sales-payment',
          meta: {
            title: '到账管理',
            ignoreBreadCrumb: true
          },
          component: () => import('@/view/v5/statement/payment/index.vue')
        },
        {
          path: 'dzdchangedetail/:projId/:orgId',
          name: 'sales-payment-dzd-detail',
          meta: {
            hideInTabBar: true,
            title: '到账单变更明细'
          },
          component: () => import('@/view/v5/statement/dzd/detail.vue')
        },
        {
          path: 'dzdbalancedetail/:projId/:orgId',
          name: 'sales-payment-dzd-detail',
          meta: {
            hideInTabBar: true,
            title: '到账单结算明细'
          },
          component: () => import('@/view/v5/statement/dzd/balance.vue')
        },
        {
          path: 'prepay/:id',
          name: 'sales-payment-prepay-detail',
          meta: {
            hideInTabBar: true,
            title: '预付款单详情'
          },
          component: () => import('@/view/v5/statement/payment/prepay.vue')
        },
        {
          path: 'last/:id',
          name: 'sales-payment-last-detail',
          meta: {
            hideInTabBar: true,
            title: '尾款单详情'
          },
          component: () => import('@/view/v5/statement/payment/last.vue')
        },
        {
          path: `org/:orgId`,
          name: 'sales-payment-org-details',
          meta: {
            title: '会员详情',
            hideInTabBar: true
          },
          component: () => import('@/view/member/org-query/details.vue')
        },
        {
          path: 'project/:code',
          meta: {
            title: '项目详情',
            hideInTabBar: true
          },
          name: 'self-sales-projcet',
          component: () => import('@/view/v5/statement/project.vue')
        },
        {
          path: 'detail/:projId/:orgId',
          meta: {
            title: '到账明细',
            hideInTabBar: true
          },
          name: 'cache-self-statement-dzd-confirm-preAccount',
          component: () => import('@/view/v5/statement/dzd/accountDetail.vue')
        },
        {
          path: 'balance/:projId/:orgId',
          meta: {
            title: '尾款明细',
            hideInTabBar: true
          },
          name: 'self-statement-dzd-confirm-balanceAccount',
          component: () => import('@/view/v5/statement/dzd/balanceDetail.vue')
        }
      ]
    },
    {
      path: 'confirm',
      name: 'self-order-dzd-confirm',
      meta: {
        title: '到账确认'
      },
      component: () => import('@/view/v5/statement/dzd/confirm.vue')
    },
    {
      path: 'sale',
      meta: {
        title: '销售对账单'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          name: 'self-statement-sale',
          meta: {
            title: '销售对账单列表',
            ignoreBreadCrumb: true
          },
          component: () => import("@/view/v5/statement/saleRecord/list.vue")
        },
        {
          path: "detail/:id",
          name: "self-statement-sale-detail",
          meta: {
            title: "销售对账单详情"
          },
          component: () => import("@/view/v5/statement/saleRecord/detail.vue")
        },
        {
          path: "add",
          name: "self-statement-sale-add-detail",
          meta: {
            title: "创建对账单详情"
          },
          component: () => import("@/view/v5/statement/saleRecord/addDetail.vue")
        }
      ]
    },
    {
      path: 'purchase',
      meta: {
        title: '采购对账单'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          name: 'self-statement-purchase',
          meta: {
            title: '采购对账单列表'
          },
          component: () => import("@/view/v5/statement/purchaseRecord/list.vue")
        },
        {
          path: "detail/:id",
          name: "self-statement-purchase-detail",
          meta: {
            title: "采购对账单详情"
          },
          component: () => import("@/view/v5/statement/purchaseRecord/detail.vue")
        },
        {
          path: "add",
          name: "self-statement-purchase-add-detail",
          meta: {
            title: "创建对账单详情"
          },
          component: () => import("@/view/v5/statement/purchaseRecord/addDetail.vue")
        }
      ]
    },
    {
      path: '',
      meta: {
        title: '收款管理'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: 'receiptRegister',
          name: 'self-statement-receiptRegister',
          meta: {
            title: '收款登记',
            ignoreBreadCrumb: true
          },
          component: () => import("@/view/v5/statement/receiptManage/receiptRegister/index.vue")
        },
        {
          path: 'receiptRegister/bind/:id',
          name: 'self-statement-receiptBind',
          meta: {
            title: '收款关联管理'
          },
          component: () => import("@/view/v5/statement/receiptManage/receiptRegister/bind.vue")
        },
        {
          path: 'receiptRecords',
          name: 'self-statement-receiptRecords',
          meta: {
            title: '收款绑定记录'
          },
          component: () => import("@/view/v5/statement/receiptManage/receiptRecords/index.vue")
        },
        {
          path: 'receiptChange',
          name: 'self-statement-receiptChange',
          meta: {
            title: '预收款变更'
          },
          component: () => import("@/view/v5/statement/receiptManage/receiptChange/index.vue")
        },
        {
          path: 'receiptChange/detail/:id',
          name: 'self-statement-changeDetail',
          meta: {
            title: '预收款变更单'
          },
          component: () => import("@/view/v5/statement/receiptManage/receiptChange/detail.vue")
        },
        {
          path: 'receiptChange/add',
          name: 'self-statement-addChange',
          meta: {
            title: '新增预收款变更单'
          },
          component: () => import("@/view/v5/statement/receiptManage/receiptChange/add.vue")
        },
        {
          path: 'receiptChange/edit/:id',
          name: 'self-statement-editChange',
          meta: {
            title: '编辑预收款变更单'
          },
          component: () => import("@/view/v5/statement/receiptManage/receiptChange/edit.vue")
        },
        {
          path: 'reversePayment',
          name: 'self-statement-reversePayment',
          meta: {
            title: '冲销付款'
          },
          component: () => import("@/view/v5/statement/paymentManage/reversePayment/index.vue")
        },
        {
          path: 'reversePayment/bind/:id',
          name: 'self-statement-reversePaymentBind',
          meta: {
            title: '冲销付款关联管理'
          },
          component: () => import("@/view/v5/statement/paymentManage/reversePayment/bind.vue")
        },
        {
          path: 'payRegister',
          name: 'self-statement-payRegister',
          meta: {
            title: '付款登记'
          },
          component: () => import("@/view/v5/statement/paymentManage/payRegister/index.vue")
        },
        {
          path: 'payRegister/bind/:id',
          name: 'self-statement-payRegisterBind',
          meta: {
            title: '付款登记关联管理'
          },
          component: () => import("@/view/v5/statement/paymentManage/payRegister/bind.vue")
        },
        {
          path: 'reverseReceipt',
          name: 'self-statement-reverseReceipt',
          meta: {
            title: '冲销项目收款'
          },
          component: () => import("@/view/v5/statement/receiptManage/reverseReceipt/index.vue")
        },
        {
          path: 'reverseReceipt/bind/:id',
          name: 'self-statement-reverseReceiptBind',
          meta: {
            title: '冲销项目收款管理'
          },
          component: () => import("@/view/v5/statement/receiptManage/reverseReceipt/bind.vue")
        },
        {
          path: 'payRecords',
          name: 'self-statement-payRecords',
          meta: {
            title: '付款绑定记录'
          },
          component: () => import("@/view/v5/statement/paymentManage/payRecords/index.vue")
        },
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/v5/statement.js